import { render } from "./CalculaterDetailPage.vue?vue&type=template&id=3f40d371&scoped=true"
import script from "./CalculaterDetailPage.vue?vue&type=script&lang=js"
export * from "./CalculaterDetailPage.vue?vue&type=script&lang=js"

import "./CalculaterDetailPage.vue?vue&type=style&index=0&id=3f40d371&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f40d371"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard,QCardSection,QSeparator,QSelect,QItem,QItemSection,QInput,QBadge});
